export default __webpack_public_path__ + "static/media/DSC_0554.ea323892.webp";